import _extends from '@babel/runtime/helpers/extends';
import { forwardRef, useFormControlContext, useStyleConfig, chakra } from '@chakra-ui/react';
import { cx } from '@chakra-ui/utils';
import * as React from 'react';

/**
 * Used to show a "required" text or an asterisks (*) to indicate that
 * a field is required.
 */
var RequiredIndicator = forwardRef(function (props, ref) {
  var field = useFormControlContext();
  var styles = useStyleConfig('RequiredIndicator');
  var className = cx('chakra-label__required-indicator', props.className);
  return /*#__PURE__*/React.createElement(chakra.span, _extends({}, field === null || field === void 0 ? void 0 : field.getRequiredIndicatorProps(props, ref), {
    __css: styles,
    className: className
  }), "*");
});
export { RequiredIndicator };